<template>
  <div class="card p-4 shadow-sm">
    <!-- Toast de alerta -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <h4 class="mb-4">
      <i class="bx bx-package"></i> Inventario Sobrante de Limpieza
    </h4>

    <!-- Tabs -->
    <ul class="nav nav-tabs mb-4" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: vistaActual === 'pendientes' }"
          @click="cambiarVista('pendientes')"
        >
          Pendientes
          <span v-if="productosPendientes.length > 0" class="badge bg-warning ms-1">
            {{ productosPendientes.length }}
          </span>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: vistaActual === 'historial' }"
          @click="cambiarVista('historial')"
        >
          Historial
        </button>
      </li>
    </ul>

    <!-- Vista Pendientes -->
    <div v-if="vistaActual === 'pendientes'">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Productos Pendientes de Revisión</h5>
        <div>
          <button
            v-if="seleccionados.length > 0"
            class="btn btn-success btn-sm me-2"
            @click="aprobarSeleccionados"
          >
            <i class="bx bx-check"></i> Aprobar Seleccionados ({{ seleccionados.length }})
          </button>
          <button
            v-if="productosPendientes.length > 0"
            class="btn btn-primary btn-sm"
            @click="aprobarTodos"
          >
            <i class="bx bx-check-double"></i> Aprobar Todos
          </button>
        </div>
      </div>

      <!-- Tabla Pendientes -->
      <div class="table-responsive">
        <table class="table table-hover table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th style="width: 40px;">
                <input
                  type="checkbox"
                  @change="toggleTodos"
                  :checked="seleccionados.length === productosPendientes.length && productosPendientes.length > 0"
                >
              </th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Habitación</th>
              <th>Origen</th>
              <th>Fecha</th>
              <th>Empleado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="productosPendientes.length === 0">
              <td colspan="8" class="text-muted py-4">
                <i class="bx bx-inbox" style="font-size: 3rem;"></i>
                <p class="mb-0 mt-2">No hay productos sobrantes pendientes</p>
              </td>
            </tr>
            <tr v-for="prod in productosPendientes" :key="prod.IdInventarioSobrante">
              <td>
                <input
                  type="checkbox"
                  :value="prod.IdInventarioSobrante"
                  v-model="seleccionados"
                >
              </td>
              <td>{{ prod.Producto }}</td>
              <td><span class="badge bg-info">{{ prod.Cantidad }}</span></td>
              <td>{{ prod.Habitacion }}</td>
              <td>
                <span
                  class="badge"
                  :class="prod.Origen === 'Lavandería' ? 'bg-secondary' : 'bg-primary'"
                >
                  {{ prod.Origen }}
                </span>
              </td>
              <td>{{ formatearFecha(prod.FechaRegistro) }}</td>
              <td class="text-muted small">{{ prod.Empleado }}</td>
              <td>
                <button
                  class="btn btn-success btn-sm me-1"
                  @click="mostrarModalAprobar(prod)"
                  title="Agregar al inventario"
                >
                  <i class="bx bx-check"></i>
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="rechazarProducto(prod.IdInventarioSobrante)"
                  title="Rechazar"
                >
                  <i class="bx bx-x"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Vista Historial -->
    <div v-if="vistaActual === 'historial'">
      <h5 class="mb-3">Historial de Productos Sobrantes</h5>

      <!-- Buscador -->
      <div class="mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por producto, habitación o empleado..."
          v-model="busqueda"
        />
      </div>

      <!-- Tabla Historial -->
      <div class="table-responsive">
        <table class="table table-striped table-bordered text-center align-middle">
          <thead class="table-dark">
            <tr>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Habitación</th>
              <th>Origen</th>
              <th>Fecha</th>
              <th>Empleado</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="historialFiltrado.length === 0">
              <td colspan="7" class="text-muted py-4">No hay registros en el historial</td>
            </tr>
            <tr v-for="prod in historialFiltrado" :key="prod.IdInventarioSobrante">
              <td>{{ prod.Producto }}</td>
              <td>{{ prod.Cantidad }}</td>
              <td>{{ prod.Habitacion }}</td>
              <td>
                <span
                  class="badge"
                  :class="prod.Origen === 'Lavandería' ? 'bg-secondary' : 'bg-primary'"
                >
                  {{ prod.Origen }}
                </span>
              </td>
              <td>{{ formatearFecha(prod.FechaRegistro) }}</td>
              <td class="text-muted small">{{ prod.Empleado }}</td>
              <td>
                <span
                  class="badge"
                  :class="{
                    'bg-success': prod.Estado === 'aprobado',
                    'bg-danger': prod.Estado === 'rechazado',
                    'bg-warning': prod.Estado === 'pendiente'
                  }"
                >
                  {{ prod.Estado.toUpperCase() }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal de Confirmación -->
    <div v-if="mostrarModal" class="modal-backdrop" @click.self="cerrarModal">
      <div class="modal-content">
        <h5 class="mb-3">{{ modalTitulo }}</h5>
        <p>{{ modalMensaje }}</p>
        <div class="d-flex justify-content-end gap-2 mt-4">
          <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
          <button
            class="btn"
            :class="modalTipo === 'danger' ? 'btn-danger' : 'btn-primary'"
            @click="confirmarAccion"
          >
            {{ modalBotonTexto }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Cantidad para Aprobar -->
    <div v-if="mostrarModalCantidad" class="modal-backdrop" @click.self="cerrarModalCantidad">
      <div class="modal-content">
        <h5 class="mb-3">
          <i class="bx bx-check-circle text-success"></i> Aprobar Producto
        </h5>
        <div class="mb-3">
          <p><strong>Producto:</strong> {{ productoActual.Producto }}</p>
          <p><strong>Cantidad reportada:</strong> {{ productoActual.Cantidad }}</p>
          <p class="text-muted small">Solo ingresa la cantidad en buen estado que se agregará al inventario general.</p>
        </div>
        <div class="mb-3">
          <label class="form-label">Cantidad a aprobar:</label>
          <input
            type="number"
            class="form-control"
            v-model.number="cantidadAprobar"
            :min="1"
            :max="productoActual.Cantidad"
            @keyup.enter="aprobarConCantidad"
            ref="inputCantidad"
          />
          <small class="text-danger" v-if="cantidadAprobar > productoActual.Cantidad">
            La cantidad no puede ser mayor a {{ productoActual.Cantidad }}
          </small>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-4">
          <button class="btn btn-secondary" @click="cerrarModalCantidad">Cancelar</button>
          <button
            class="btn btn-success"
            @click="aprobarConCantidad"
            :disabled="cantidadAprobar < 1 || cantidadAprobar > productoActual.Cantidad"
          >
            <i class="bx bx-check"></i> Aprobar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "InventarioSobrante",
  data() {
    return {
      vistaActual: "pendientes",
      productosPendientes: [],
      historial: [],
      busqueda: "",
      seleccionados: [],
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      mostrarModal: false,
      modalTitulo: "",
      modalMensaje: "",
      modalTipo: "primary",
      modalBotonTexto: "Confirmar",
      accionPendiente: null,
      idPendiente: null,
      // Nuevo: para modal de cantidad
      mostrarModalCantidad: false,
      productoActual: {},
      cantidadAprobar: 0
    };
  },
  computed: {
    historialFiltrado() {
      if (!this.busqueda.trim()) {
        return this.historial;
      }
      const buscar = this.busqueda.toLowerCase();
      return this.historial.filter(h =>
        h.Producto.toLowerCase().includes(buscar) ||
        h.Habitacion.toLowerCase().includes(buscar) ||
        h.Empleado.toLowerCase().includes(buscar)
      );
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    cerrarModalCantidad() {
      this.mostrarModalCantidad = false;
      this.productoActual = {};
      this.cantidadAprobar = 0;
    },
    mostrarModalAprobar(producto) {
      this.productoActual = producto;
      this.cantidadAprobar = producto.Cantidad; // Por defecto aprobar toda la cantidad
      this.mostrarModalCantidad = true;
      // Focus en el input después de que se renderice el modal
      this.$nextTick(() => {
        if (this.$refs.inputCantidad) {
          this.$refs.inputCantidad.focus();
          this.$refs.inputCantidad.select();
        }
      });
    },
    async aprobarConCantidad() {
      if (this.cantidadAprobar < 1 || this.cantidadAprobar > this.productoActual.Cantidad) {
        this.mostrarAlerta("Cantidad inválida", "danger");
        return;
      }

      try {
        const { data } = await axios.post(
          `${API_URL}/inventario-sobrante/${this.productoActual.IdInventarioSobrante}/aprobar`,
          { cantidad: this.cantidadAprobar }
        );
        this.mostrarAlerta(data.message, "success");
        this.cerrarModalCantidad();
        this.obtenerPendientes();
      } catch (error) {
        console.error("Error aprobando producto:", error);
        this.mostrarAlerta(
          error.response?.data?.message || "No se pudo aprobar el producto",
          "danger"
        );
      }
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.accionPendiente = null;
      this.idPendiente = null;
    },
    abrirModal(titulo, mensaje, tipo, botonTexto, accion, id = null) {
      this.modalTitulo = titulo;
      this.modalMensaje = mensaje;
      this.modalTipo = tipo;
      this.modalBotonTexto = botonTexto;
      this.accionPendiente = accion;
      this.idPendiente = id;
      this.mostrarModal = true;
    },
    async confirmarAccion() {
      if (this.accionPendiente) {
        await this.accionPendiente();
      }
      this.cerrarModal();
    },
    cambiarVista(vista) {
      this.vistaActual = vista;
      if (vista === "historial") {
        this.obtenerHistorial();
      }
    },
    async obtenerPendientes() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-sobrante`);
        this.productosPendientes = data;
      } catch (error) {
        console.error("Error obteniendo pendientes:", error);
        this.mostrarAlerta("No se pudieron cargar los productos pendientes", "danger");
      }
    },
    async obtenerHistorial() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-sobrante/historial`);
        this.historial = data;
      } catch (error) {
        console.error("Error obteniendo historial:", error);
        this.mostrarAlerta("No se pudo cargar el historial", "danger");
      }
    },
    aprobarProducto(id) {
      this.abrirModal(
        "¿Aprobar producto?",
        "Este producto se agregará al inventario correspondiente",
        "primary",
        "Sí, aprobar",
        async () => {
          try {
            const { data } = await axios.post(`${API_URL}/inventario-sobrante/${id}/aprobar`);
            this.mostrarAlerta(data.message, "success");
            this.obtenerPendientes();
          } catch (error) {
            console.error("Error aprobando producto:", error);
            this.mostrarAlerta(error.response?.data?.message || "No se pudo aprobar el producto", "danger");
          }
        },
        id
      );
    },
    rechazarProducto(id) {
      this.abrirModal(
        "¿Rechazar producto?",
        "Este producto será descartado y no se agregará al inventario",
        "danger",
        "Sí, rechazar",
        async () => {
          try {
            const { data } = await axios.post(`${API_URL}/inventario-sobrante/${id}/rechazar`);
            this.mostrarAlerta(data.message, "success");
            this.obtenerPendientes();
          } catch (error) {
            console.error("Error rechazando producto:", error);
            this.mostrarAlerta(error.response?.data?.message || "No se pudo rechazar el producto", "danger");
          }
        },
        id
      );
    },
    aprobarTodos() {
      this.abrirModal(
        "¿Aprobar todos los productos?",
        `Se aprobarán ${this.productosPendientes.length} productos y se agregarán a sus inventarios correspondientes`,
        "primary",
        "Sí, aprobar todos",
        async () => {
          try {
            const { data } = await axios.post(`${API_URL}/inventario-sobrante/aprobar-todos`);
            this.mostrarAlerta(data.message, "success");
            this.obtenerPendientes();
            this.seleccionados = [];
          } catch (error) {
            console.error("Error aprobando todos:", error);
            this.mostrarAlerta(error.response?.data?.message || "No se pudieron aprobar los productos", "danger");
          }
        }
      );
    },
    aprobarSeleccionados() {
      this.abrirModal(
        "¿Aprobar productos seleccionados?",
        `Se aprobarán ${this.seleccionados.length} productos`,
        "primary",
        "Sí, aprobar",
        async () => {
          try {
            const { data } = await axios.post(`${API_URL}/inventario-sobrante/aprobar-seleccionados`, {
              ids: this.seleccionados
            });
            this.mostrarAlerta(data.message, "success");
            this.obtenerPendientes();
            this.seleccionados = [];
          } catch (error) {
            console.error("Error aprobando seleccionados:", error);
            this.mostrarAlerta(error.response?.data?.message || "No se pudieron aprobar los productos", "danger");
          }
        }
      );
    },
    toggleTodos(event) {
      if (event.target.checked) {
        this.seleccionados = this.productosPendientes.map(p => p.IdInventarioSobrante);
      } else {
        this.seleccionados = [];
      }
    },
    formatearFecha(fecha) {
      if (!fecha) return "N/A";
      const d = new Date(fecha);
      return d.toLocaleString("es-GT", {
        dateStyle: "short",
        timeStyle: "short"
      });
    }
  },
  mounted() {
    this.obtenerPendientes();
  }
};
</script>

<style scoped>
.nav-tabs .nav-link {
  cursor: pointer;
  color: #64748b;
}

.nav-tabs .nav-link.active {
  color: #1e40af;
  font-weight: 600;
}

.table th {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table td {
  font-size: 0.875rem;
  vertical-align: middle;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  width: 500px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
